module.exports = __webpack_public_path__ + "static/media/400384_02.c1748a38.png";